// Shared "read-only for your role" notice shown above protected KYC areas when the
// signed-in user's role may view but not change them (Staff front). Purely visual —
// enforcement lives in each section's readOnly prop, the masked save and Firestore rules.
import "../css/KycReadOnlyBanner.css";

export default function KycReadOnlyBanner({ visible = false, children }) {
  if (!visible) return null;
  return (
    <div className="kycReadOnlyBanner" role="note">
      <i className="bi bi-eye kycReadOnlyBannerIcon" aria-hidden="true" />
      <span>
        {children ||
          "View only for your role — compliance decisions in this section are made by Staff compliance."}
      </span>
    </div>
  );
}
